import React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import Title from "./Title";
import Privacy from "./Privacy";

const PrivacyPolicy = () => {
	return (
		<>
			<Header />
			<Title />
			<Privacy />
			<Footer />
		</>
	);
};
export default PrivacyPolicy;
